module.exports = __webpack_public_path__ + "static/img/xAxis.9b743775.svg";